import CoreStore from '@/core/store';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';

const coreStore = getModule(CoreStore, store);

export const sessionResolver = async (): Promise<void> => {
	await coreStore.getAndSetSession();
};
